import { AbstractGridListingFilter, type IGridListingFilterValue } from '../grid.listing.filter';
import { DateTime } from '../../../system/services';
import moment from 'moment';

export interface IDateRange {
    from?: string;
    to?: string;
}

export class DateRangeGridListingFilter extends AbstractGridListingFilter {
    private postfixFrom = '.from';
    private postfixTo = '.to';
    private start = '';
    private end = '';

    constructor(
        filterName: string,
        private fieldName: string,
        scopeVariable: IDateRange = null,
        private withTime: boolean = true
    ) {
        super(filterName, scopeVariable);
    }

    public setPostfix(from, to) {
        this.postfixFrom = from;
        this.postfixTo = to;
    }

    public setDateRange(start: string, end: string) {
        this.start = start;
        this.end = end;
    }

    public values() {
        return [
            {
                name: this.fieldName + this.postfixFrom,
                value: this.value('from')
            },
            {
                name: this.fieldName + this.postfixTo,
                value: this.value('to')
            }
        ];
    }

    public value(variable) {
        let result = undefined;
        if (this.scopeVariable[variable]) {
            result = this.scopeVariable[variable];
        }
        if (!result) {
            if (variable == 'from' && this.start) {
                result = this.start;
            }
            if (variable == 'to' && this.end) {
                result = this.end;
            }
        }
        if (result && this.withTime) {
            result = variable == 'to' ? this.prepareToDate(result) : this.prepareFromDate(result);
        }
        return result;
    }

    title(name, value) {
        if (value) {
            const format = DateTime.getInstance().format.date;
            const momentObjectFrom = moment(value);
            return momentObjectFrom.format(format);
        }
        return '';
    }

    public descriptions() {
        return (values: IGridListingFilterValue[]) => {
            const titles: string[] = [];
            values.forEach(item => {
                if (item.value) {
                    titles.push(this.title(item.name, item.value));
                }
            });

            return {
                quick: this.quick,
                empty: this.noBottom,
                titles: titles.length ? [titles.join(' - ')] : []
            };
        };
    }

    public isEmpty() {
        let empty = true;
        this.values().forEach(item => {
            empty = empty && (!item.value || item.value === '');
        });
        return empty;
    }

    public clear() {
        this.scopeVariable.from = '';
        this.scopeVariable.to = '';
    }

    private prepareFromDate(date: string): string {
        const momentObject = moment(date);
        momentObject.set({
            hour: 0,
            minute: 0,
            second: 0
        });
        return momentObject.format('YYYY-MM-DDTHH:mm:ss');
    }

    private prepareToDate(date: string): string {
        const momentObject = moment(date);
        momentObject.set({
            hour: 23,
            minute: 59,
            second: 59
        });
        return momentObject.format('YYYY-MM-DDTHH:mm:ss');
    }
}
